<template>
  <div class="d-modal__employment text-dark">
    <button @click="openIsModal"><span class="icon-pencil"></span></button>
    <DModal v-if="isModal" :showClose="false" class="d-modal__employment-modal">
      <div slot="insertComponent">
        <div class="d-modal__header">
          <h2>Ansættelser for {{ userName }}</h2>
          <div class="font-large icon__bg-circle d-modal__header__close" @click="closeIsModal"><span
            class="icon-cross2"></span></div>
        </div>
        <div class="d-modal__body">
          <div class="is-loading-container" v-if="!isAllDoneLoading">
            <Loader :isLoaderModal="true"></Loader>
          </div>
          <template v-else>
            <h4 class="text-explainer" v-if="userEmployments.length === 0">Ingen ansættelser oprettet</h4>
            <div class="d-modal__employment__employments" v-if="userEmployments.length > 0">
              <ul>
                <li class="d-modal__employment__employments__header">
                  <div>Ansættelse</div>
                  <div>CPR NUMMER + EKSTRACIFFER</div>
                </li>
                <li v-for="userEmployment in userEmploymentsWithTitle"
                    class="d-modal__employment__employments__employment"
                    :key="userEmployment.id">
                  <div class="d-modal__employment__employments__employment__container">
                    <div>{{ userEmployment.title }}</div>
                    <div>{{ userEmployment.employment_number }}</div>
                  </div>
                  <span class="icon__bg-circle icon__bg-circle--danger"
                        @click="setDeleteEmployment(userEmployment)">
                    <span class="icon-bin"></span>
                  </span>
                </li>
                <li class="text-blue text-link marg-1-bottom" @click="isShowArchived = !isShowArchived" v-if="userDeletedEmployments.length > 0">
                  <span v-if="!isShowArchived">Se</span><span v-if="isShowArchived">Skjul</span> tidligere ansættelser
                </li>
                <li v-for="userEmployment in deletedUserEmploymentsWithTitle"
                    v-if="isShowArchived"
                    class="d-modal__employment__employments__employment d-modal__employment__employments__employment--deleted"
                    :key="userEmployment.id">
                  <div class="d-modal__employment__employments__employment__container">
                    <div>{{ userEmployment.title }}</div>
                    <div>{{ userEmployment.employment_number }}</div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="d-modal__buttons">
              <button v-if="!isCreateForm" @click="setIsCreateForm(true)">Tilføj ansættelse</button>
            </div>
            <transition name="scaleIn" mode="out-in">
              <div class="d-modal__employment__form" v-if="isCreateForm">
                <h4>Tilføj ansættelse</h4>
                <div class="input-group-flex">
                  <div class="input-group flex-1 input-group__select">
                    <label>Ansættelsestype</label>
                    <select v-model="createFormEmploymentTypeId" @change="removeErrors('type')"
                            :class="{'input--error': formErrors['type']}">
                      <option v-for="employmentType in employmentTypesActive" :value="employmentType.id">
                        {{ employmentType.title }}
                      </option>
                    </select>
                    <p class="input-error" v-if="formErrors['type']">{{ formErrors['type'] }}</p>
                  </div>
                  <div class="input-group flex-1">
                    <label>CPR nummer</label>
                    <input type="text" v-model.trim="createFormCPR" @keyup="removeErrors('cpr')"
                           :class="{'input--error': formErrors['cpr']}">
                    <p class="input-error" v-if="formErrors['cpr']">{{ formErrors['cpr'] }}</p>
                  </div>
                  <div class="input-group flex-1 extra-ciffer-input">
                    <label>Ekstraciffer</label>
                    <input type="number" v-model.trim="createFormExtraCiffer" @keyup="removeErrors('ciffer')"
                           :class="{'input--error': formErrors['ciffer']}">
                    <p class="input-error" v-if="formErrors['ciffer']">{{ formErrors['ciffer'] }}</p>
                  </div>
                </div>
                <div class="d-modal__buttons">
                  <button class="marg-10-right" @click="closeIsCreateForm">{{ $t('vue2.common.cancel') }}</button>
                  <button class="submit-button" @click="createEmployment">Tilføj ansættelse</button>
                </div>
              </div>
            </transition>
          </template>
        </div>
      </div>
    </DModal>
    <DModal v-if="theDeleteEmployment" :showClose="false">
      <div class="d-modal__delete-employment" slot="insertComponent">
        <div class="d-modal__header">
          <h2>Vil du slette ansættelsen?</h2>
          <div class="font-large icon__bg-circle d-modal__header__close" @click="theDeleteEmployment = null"><span
            class="icon-cross2"></span></div>
        </div>
        <div class="d-modal__body">
          <p>Vil du slette <b><i>{{ theDeleteEmployment.title }}</i></b> for {{ userName }}</p>
          <div class="d-modal__buttons">
            <button class="marg-10-right" @click="theDeleteEmployment = null">Nej</button>
            <button class="submit-button" @click="deleteEmployment">Ja, slet ansættelsen</button>
          </div>
        </div>
      </div>
    </DModal>
    <div class="bg-overlay" v-if="isModal"></div>
  </div>
</template>

<script>
import DModal from '../common/DModal'
import docendo from '../../docendo'
import Loader from '../common/Loader'
import eventbus from '../../eventbus'

export default {
  components: {Loader, DModal},
  props: {
    userId: {
      default: 13
    },
    userName: {
      default: 'Henrik'
    }
  },
  data () {
    return {
      isModal: false,
      isLoading: true,
      isCreateForm: false,
      createFormCPR: '',
      createFormExtraCiffer: '',
      createFormEmploymentTypeId: null,
      employments: [],
      schoolEmployments: [],
      theDeleteEmployment: null,
      formErrors: {},
      isShowArchived: false
    }
  },
  computed: {
    createFormEmploymentNumber () {
      let cpr = this.createFormCPR.replace(/[^0-9]/ig, '')
      return cpr.toString() + this.createFormExtraCiffer.toString()
    },
    isEmploymentTypesLoading () {
      return this.$store.getters.isLoadingEmploymentsTypesForSchool
    },
    isAllDoneLoading () {
      return !this.isLoading && !this.isEmploymentTypesLoading
    },
    employmentTypes () {
      return this.$store.state.employments.employmentsTypes
    },
    employmentTypesActive () {
      return this.employmentTypes.filter(type => !type.deleted)
    },
    userEmployments () {
      return this.employments.filter(employment => !employment.deleted)
    },
    userDeletedEmployments () {
      return this.employments.filter(employment => employment.deleted)
    },
    userEmploymentsWithTitle () {
      let arr = []
      this.userEmployments.forEach(employment => {
        const title = this.getEmploymentTypeTitle(employment.employment_type_id)
        this.$set(employment, 'title', title)
        arr.push(employment)
      })
      return arr
    },
    deletedUserEmploymentsWithTitle () {
      let arr = []
      this.userDeletedEmployments.forEach(employment => {
        const title = this.getEmploymentTypeTitle(employment.employment_type_id)
        this.$set(employment, 'title', title)
        arr.push(employment)
      })
      return arr
    }
  },
  methods: {
    removeErrors (title) {
      this.$delete(this.formErrors, title)
    },
    formValidation () {
      this.formErrors = {}
      if (!this.createFormEmploymentTypeId) {
        this.$set(this.formErrors, 'type', 'Vælg en type')
      }
      if (!this.validateCPR()) {
        this.$set(this.formErrors, 'cpr', 'Er ikke et gyldigt CPR nummer')
      }
      if (this.createFormExtraCiffer.length < 1) {
        this.$set(this.formErrors, 'ciffer', 'Skal sættes')
      }
      if (this.validateCPRAndCifferIsAlreadyUsed()) {
        this.$set(this.formErrors, 'cpr', 'CPR nummer + ekstra ciffer er allerede brugt')
        this.$set(this.formErrors, 'ciffer', ' ')
      }
    },
    validateCPRAndCifferIsAlreadyUsed () {
      let idx = this.userEmployments.findIndex(employment => employment.employment_number.toString() === this.createFormEmploymentNumber.toString())
      return idx > -1
    },
    validateCPR () {
      //  Validate CPR-nr.
      let cpr = this.createFormCPR
      let res = cpr.replace(/[^0-9]/ig, '')
      if (res.length !== 10) {
        return false
      } else {
        return true
      }
    },
    closeIsModal () {
      this.closeIsCreateForm()
      this.isModal = false
    },
    setIsCreateForm (boolean) {
      if (boolean) {
        this.isCreateForm = true
      }
    },
    resetForm () {
      this.createFormCPR = ''
      this.createFormExtraCiffer = ''
      this.createFormEmploymentTypeId = null
      this.formErrors = {}
    },
    closeIsCreateForm () {
      this.resetForm()
      if (this.userEmployments.length < 1) {
        this.isModal = false
      }
      this.isCreateForm = false
    },
    openIsModal () {
      this.getUserEmployments()
      this.isModal = true
    },
    createEmployment () {
      this.formValidation()
      if (Object.keys(this.formErrors).length > 0) {
        return
      }
      docendo.createEmployment(window.SCHOOL.id, this.userId, this.createFormEmploymentNumber, this.createFormEmploymentTypeId, success => {
        this.employments.push(success)
        this.closeIsCreateForm()
        eventbus.toast = {text: 'Ansættelsen er oprettet', success: true}
        this.$store.dispatch('readEmployments')
      }, failure => {
        console.log('FAILED', failure)
        this.$store.dispatch('readEmployments')
      })
    },
    getUserEmployments () {
      this.isLoading = true
      docendo.employmentsForSchoolForUser(window.SCHOOL.id, this.userId, success => {
        this.employments = success
        this.isLoading = false
        if (this.employments.length < 1) {
          this.isCreateForm = true
        }
      }, failure => {
        console.log('failed', failure)
      })
    },
    setDeleteEmployment (employment) {
      this.theDeleteEmployment = employment
    },
    deleteEmployment () {
      docendo.deleteEmployment(window.SCHOOL.id, this.userId, this.theDeleteEmployment.id, success => {
        eventbus.toast = {text: 'Ansættelsen er slettet', success: true}
        this.getUserEmployments()
        this.theDeleteEmployment = null
        this.$store.dispatch('readEmployments')
      }, failure => {
        eventbus.toast = {text: 'Noget gik galt', success: false}
        this.getUserEmployments()
        this.theDeleteEmployment = null
        this.$store.dispatch('readEmployments')
      })
    },
    getAllEmployments () {
      docendo.employmentsForSchool(window.SCHOOL.id, success => {
        this.schoolEmployments = success
      }, failure => {
        console.log('failure')
      })
    },
    getEmploymentTypeTitle (employmentTypeId) {
      let employmentIdStr = employmentTypeId * 1
      let idx = this.employmentTypes.findIndex(employment => employment.id === employmentIdStr)
      return idx > -1 ? this.employmentTypes[idx].title : '?'
    }
  },
  mounted () {
    this.$store.dispatch('readEmploymentTypes')
    this.$store.dispatch('readEmployments')
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-modal__employment .d-modal__employment-modal .d-modal__body {
  width: 700px;
}

.d-modal__employment .d-modal__header {
  margin-bottom: 0;
}

.table-lite tbody tr td .d-modal__employment input {
  padding: 9px;
  width: 100%;
  display: block;
  border: 1px solid #acb6be;
  border-radius: 4px;
  text-align: left;
  background: #fff;
}

.table-lite tbody tr td .d-modal__employment input:focus {
  border-color: var(--blue);
}

.d-modal__delete-employment {
  width: 400px;
}

.input-group input {
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);
}

.input-group select {
  height: 34px;
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);
}

.input-group-flex {
  display: flex;
  align-items: flex-start;
}

.input-group-flex .input-group {
  width: 50%;
  flex: 1;
  margin-right: 1rem;
}

.d-modal__employment label {
  margin-bottom: 0.5rem;
}

.d-modal__employment .input-group {
  margin-top: 1rem;
}

.d-modal__employment .d-modal__buttons {
  margin-top: 2rem;
}

.input-group__select {
  max-width: 120px;
}

.input-group__select select {
  width: 120px;
}

.input-group__select select.input--error {
  border: 1px solid red;
}

.d-modal__employment__employments ul {
  margin: 0;
}

.d-modal__employment__employments__header {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  margin-right: 30px;
}

.d-modal__employment__employments__header > div {
  flex: 1;
  font-weight: bold;
}

.d-modal__employment__employments__employment {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.d-modal__employment__employments__employment--deleted > div {
  background: #eeeeee;
}


.d-modal__employment__employments__employment__container {
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid var(--border-color);
  padding: 1rem;
  border-radius: 4px;
}

.d-modal__employment__employments__employment > div, .d-modal__employment__employments__employment__container > div {
  flex: 1;
}

.d-modal__employment__form {
  margin: 1rem 0 2rem;
  padding: 1rem;
  border-radius: 4px;
  border: 1px solid var(--border-color);
  background: #ffffff;
}

.d-modal__employment__form .d-modal__buttons {
  padding: 1rem;
  margin: 2rem -1rem -1rem;
  border-radius: 0 0 4px 4px;
}

.d-modal__employment__employments__employment__last {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.scaleIn-enter-active {
  transition: all .3s ease;
}

.scaleIn-enter, .scaleIn-leave-to {
  transform: scale(0.96);
  opacity: 0;
}

.flex-1 {
  flex: 1;
}

.hover-underline:hover {
  text-decoration: underline;
}

.extra-ciffer-input {
  max-width: 100px;
}

.text-link {
  cursor: pointer;
  display: inline-block;
}

</style>



// WEBPACK FOOTER //
// Employment.vue?4758ac17